import React, { useEffect, useState } from "react";
import { Box, Typography, IconButton, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { FaPhoneAlt, FaGlobe } from "react-icons/fa";
import CloseIcon from "@mui/icons-material/Close";
import logo from "../assets/logo.png";

const Contact = () => {
  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // true if screen < 600px

  useEffect(() => {
    // Open popup automatically when the page loads
    setIsOpen(true);
  }, []);

  const closePopup = () => setIsOpen(false);

  return (
    <>
      {isOpen && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            bgcolor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            p: 2,
          }}
        >
          <Box
            sx={{
              bgcolor: "#fff",
              p: isMobile ? 2 : 3,
              borderRadius: 2,
              width: isMobile ? "90%" : "320px",
              textAlign: "center",
              position: "relative",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            {/* Close Button */}
            <IconButton
              onClick={closePopup}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "text.secondary",
              }}
            >
              <CloseIcon />
            </IconButton>

            {/* Logo */}
            <img
                        src={logo}
                        alt="Shooin Stars Logo"
                        style={{
                          width: 50,
                          height: 50,
                          objectFit: "contain",
                          borderRadius: "8px"
                        }}
                      />

            {/* Title */}
            <Typography
              variant={isMobile ? "h6" : "h5"}
              fontWeight="bold"
              gutterBottom
            >
              SHOO-IN STARS
            </Typography>
            <Typography
              variant="body2"
              sx={{ mb: 2, fontWeight: "normal" }}
            >
              Admission Counselling
            </Typography>

            {/* Contact Info */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 1.5,
              }}
            >
              <FaPhoneAlt style={{ marginRight: 8, color: "#007BFF" }} />
              <Typography variant="body2">+91-7588776663</Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FaGlobe style={{ marginRight: 8, color: "#007BFF" }} />
              <Typography
                component="a"
                href="https://www.shooinstars.com"
                target="_blank"
                rel="noopener noreferrer"
                variant="body2"
                sx={{
                  color: "#007BFF",
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                www.shooinstars.com
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default Contact;